// Server timestamps are UTC. Render them in the viewer's own timezone
// (Melbourne for AU staff, local time for US staff) and never let a missing
// offset make the browser read UTC as local time.

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const HAS_OFFSET = /(Z|[+-]\d\d:?\d\d)$/;

const DATE_TIME_FMT = new Intl.DateTimeFormat(undefined, {
  day: '2-digit', month: 'short', year: 'numeric',
  hour: '2-digit', minute: '2-digit', hour12: false,
});
const DATE_TIME_ZONE_FMT = new Intl.DateTimeFormat(undefined, {
  day: '2-digit', month: 'short', year: 'numeric',
  hour: '2-digit', minute: '2-digit', second: '2-digit',
  hour12: false, timeZoneName: 'short',
});
const DATE_FMT = new Intl.DateTimeFormat(undefined, {
  day: '2-digit', month: 'short', year: 'numeric',
});

export function asDate(value) {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value) ? null : value;
  const raw = String(value);
  // Legacy rows were serialised without a UTC marker — they are still UTC.
  const iso = DATE_ONLY.test(raw) || HAS_OFFSET.test(raw) ? raw : raw + 'Z';
  const d = new Date(iso);
  return isNaN(d) ? null : d;
}

// "28 Sep 2026, 11:26" in the viewer's zone.
export function fmtDateTime(value) {
  const d = asDate(value);
  return d ? DATE_TIME_FMT.format(d) : '';
}

// Same, with seconds and the zone spelled out — for audit trails.
export function fmtDateTimeZone(value) {
  const d = asDate(value);
  return d ? DATE_TIME_ZONE_FMT.format(d) : '';
}

export function fmtDate(value) {
  const d = asDate(value);
  return d ? DATE_FMT.format(d) : '';
}

// "in 3 days" / "in 5 hours" / "expired" — for session expiry warnings.
export function fmtUntil(value) {
  const d = asDate(value);
  if (!d) return '';
  const mins = Math.round((d.getTime() - Date.now()) / 60000);
  if (mins <= 0) return 'expired';
  if (mins < 60) return 'in ' + mins + ' minute' + (mins === 1 ? '' : 's');
  const hours = Math.round(mins / 60);
  if (hours < 36) return 'in ' + hours + ' hour' + (hours === 1 ? '' : 's');
  const days = Math.round(hours / 24);
  return 'in ' + days + ' day' + (days === 1 ? '' : 's');
}
